import { render, staticRenderFns } from "./Stage.vue?vue&type=template&id=6c0440ea&scoped=true"
import script from "./Stage.vue?vue&type=script&lang=js"
export * from "./Stage.vue?vue&type=script&lang=js"
import style0 from "./Stage.vue?vue&type=style&index=0&id=6c0440ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0440ea",
  null
  
)

export default component.exports